export default __webpack_public_path__ + "static/media/research-general.72f30682.svg";